const urls = {
    user: {
        getUsersList: { method: 'get', url: 'users' },
        generateInviteLink: { method: 'post', url: 'invite/link' },
        addUsersInTeamsByInvitation: { method: 'post', url: 'invite/{inviteId}/clicked' },
        addUsersInTeam: { method: 'post', url: 'teams/{teamId}/add' },
        removeUsersFromTeam: { method: 'post', url: 'teams/{teamId}/remove' },
        inviteUsers: { method: 'post', url: 'users/invite' },
        getTeamUserList: { method: 'get', url: 'teams/{teamId}/members' },
        updateProfile: { method: 'put', url: 'users/{userId}' },
        deleteUser: { method: 'delete', url: 'users/{userId}' },
        getUserDetail: { method: 'get', url: 'users/{userId}' },
        postInviteLink: { method: 'post', url: 'users/invite' },
        getOnboardingProgress: { method: 'get', url: 'users/onboard' },
        userFilterList: { method: 'get', url: 'users/filter-list' },
        updateUserPreferences: { method: 'put', url: 'preferences/{preferenceId}' },
        postImageUrl: { method: 'post', url: 'media/post-url' },
        getUserBankDetails: { method: 'get', url: '/users/{id}/bank' },
        deleteOrg: { method: 'delete', url: '{orgId}/org' },
        getBankFields: { method: 'get', url: 'users/{id}/bank/fields' },
        postBankDetails: { method: 'post', url: 'users/{id}/bank' },
        postBulkInvite: { method: 'post', url: 'users/bulk-invite' },
        updateBusinessDetail: { method: 'put', url: 'users/business-details' },
        getUserGst: { method: 'get', url: 'users/gst' },
        uploadAvtar: { method: 'post', url: 'users/upload' },
        enableUser: { method: 'put', url: 'users/{id}/enable' },
        disableUser: { method: 'put', url: 'users/{id}/disable' },
        addUserTags: { method: 'post', url: 'users/{userId}/tags/add' },
        removeUserTags: { method: 'post', url: 'users/{userId}/tags/remove' },
        addTerritories: { method: 'post', url: 'users/territories' },
        removeTerritories: { method: 'post', url: 'users/territories/delete' },
        verifyUserStep: { method: 'post', url: 'users/verification/accept' },
        rejectVerifyUserStep: { method: 'post', url: 'users/verification/reject' },
        getUserTerritories: { method: 'get', url: 'users/territories' },
        rolePermissionCheck: { method: 'get', url: 'users/checks' },

        // new apis
        getNewUser: { method: 'get', url: 'users/me' },
        onboardingProgress: { method: 'get', url: 'users/flow/progress' },
        getRolesList: { method: 'get', url: 'admin/roles' },
        getOnboardingFlow: { method: 'get', url: 'users/flow/signup' },
        getSendInviteFlow: { method: 'get', url: 'users/flow/invite' },
        saveOnboardData: { method: 'post', url: 'users/onboard' },
        kycSendAadhatOtp: { method: 'post', url: 'users/kyc/aadhar/send-otp' },
        kycVerifyAadhatOtp: { method: 'post', url: 'users/kyc/aadhar/verify-otp' },
        verifyPancard: { method: 'post', url: 'users/kyc/pancard' },
        getUserPreferences: { method: 'get', url: 'preferences' },
        getUserCount: { method: 'get', url: 'users/count' },
        getUserDetails: { method: 'get', url: 'users/{userId}' },
        updateUserStatus: { method: 'put', url: 'users/{userId}/status' },
        updateUserProfile: { method: 'put', url: 'users/{userId}/profile' },
        getAdditionalDetails: { method: 'get', url: 'users/details' },
        verifyUser: { method: 'post', url: 'users/{userId}/verify/accept' },
        rejectVerifyUser: { method: 'post', url: 'users/{userId}/verify/reject' },
        workers: { method: 'get', url: 'users/{userId}/workers' },
        inviteCustomer: { method: 'post', url: 'users/invite/customer' },
        settleWallet: { method: 'post', url: 'users/{id}/settle-wallet' },
        refreshLinkedStatus: { method: 'post', url: 'users/{userId}/linked-status/refresh' },
        listVisitHistory: { method: 'get', url: 'users/{id}/visit-history' },
        toggle_auto_accept: { method: 'post', url: 'users/{id}/toggle-auto-accept' }
    },

    teams: {
        getTeams: { method: 'get', url: 'teams' },
        editTeam: { method: 'put', url: 'teams/{teamId}' },
        deleteTeam: { method: 'delete', url: 'teams/{teamId}' },
        addNewTeam: { method: 'post', url: 'teams' },
        rolesList: { method: 'get', url: 'admin/roles' },
        linkProject: { method: 'post', url: 'teams/{teamId}/projects/add' },
        unlinkProject: { method: 'post', url: 'teams/{teamId}/projects/remove' },
        getLinkedProjects: { method: 'get', url: 'teams/{teamId}/projects' },
        getTeamsDropDownList: { method: 'get', url: 'teams' },
    },
    auth: {
        logout: { method: 'post', url: 'auth/logout' },
    },
    admin: {
        checkPermission: { method: 'post', url: 'fga/check' },
        getTagsList: { method: 'get', url: 'tags' },
        getRegionsData: { method: 'get', url: 'admin/regions' },
        getDefaultMilestone: { method: 'get', url: 'admin/milestones' },
        getRemarks: { method: 'get', url: 'admin/remark' },
        createRemark: { method: 'post', url: 'admin/remark' },
        suggestAddress: { method: 'post', url: 'admin/regions/suggest' },
        addPincode: { method: 'post', url: 'admin/regions' },
    },
    projects: {
        getProjectListData: { method: 'get', url: 'projects' },
        createProject: { method: 'post', url: 'projects' },
        getContact: { method: 'get', url: 'organizations/{xOrgId}/contacts' },
        getProjectDetail: { method: 'get', url: 'projects/{projectId}' },
        updateProject: { method: 'put', url: 'projects/{projectId}' },
        getProjectTeams: { method: 'get', url: 'projects/{projectId}/teams' },
        addTeamToProject: { method: 'post', url: 'projects/{projectId}/teams' },
        removeTeamFromProject: { method: 'post', url: 'projects/{projectId}/teams/remove' },
        getProjectPost: { method: 'get', url: 'projects/{projectId}/posts' },
        projectPost: { method: 'post', url: 'projects/{projectId}/posts' },
        updateProjectPost: { method: 'put', url: 'projects/{projectId}/posts/{postId}' },
        getFilterList: { method: 'get', url: 'projects/filter-list' },
        postTeamProject: { method: 'post', url: 'teams/{id}/projects/add' },
        getProjectChecklist: { method: 'get', url: 'projects/{projectId}/milestones' },
        editProjectChecklist: { method: 'post', url: 'projects/{projectId}/milestones/{checklistId}/tasks' },
        postMileStone: { method: 'post', url: 'projects/{projectId}/milestones' },
        postMileStoneById: { method: 'post', url: 'projects/{id}/milestones/{projectMilestoneId}/tasks' },
        getProjectChecklist: { method: 'get', url: 'projects/{projectId}/milestones' },
        editProjectChecklist: { method: 'post', url: 'projects/{projectId}/milestones/{checklistId}/tasks' },
        postProjectManager: { method: 'post', url: 'projects/{id}/managers' },
        getProjectManager: { method: 'get', url: 'projects/{id}/managers' },
        blackListUser: { method: 'post', url: 'projects/{projectId}/blacklist-user' },
        whiteListUser: { method: 'post', url: 'projects/{projectId}/whitelist-user' },
        addProjectPo: { method: 'post', url: 'projects/{id}/po' },
        getProjectPo: { method: 'get', url: 'projects/{id}/po' },
        editProjectPo: { method: 'put', url: 'projects/{id}/po/{ponumber}' },
        activateProject: { method: 'put', url: 'projects/{id}/activate' },
    },

    org: {
        getOrgList: { method: 'get', url: 'organizations' },
        getOrgDetail: { method: 'get', url: 'organizations/{orgId}' },
        getContacts: { method: 'get', url: 'organizations/{orgId}/contacts' },
        getEntities: { method: 'get', url: 'organizations/{orgId}/entities' },
        postEntities: { method: 'post', url: 'organizations/{orgId}/entities' },
    },

    inventory: {
        getInventoryLocations: { method: 'get', url: 'inventory/locations' },
        createInventoryLocations: { method: 'post', url: 'inventory/locations' },
        getAssetsList: { method: 'get', url: 'assets' },
        getAssetById: { method: 'get', url: 'assets/{id}' },
        postAssetsList: { method: 'post', url: 'assets' },
        updateAssetsList: { method: 'put', url: 'assets/{id}' },
        getAssetTypeList: { method: 'get', url: 'assets/types' },
        postAssetTypeList: { method: 'post', url: 'assets/types' },
        deleteLocation: { method: 'delete', url: 'inventory/locations/{id}' },
        createAssetTypeList: { method: 'post', url: 'assets/types' },
        checkAsset: { method: 'post', url: 'assets/check' },
        updateInventoryLocation: { method: 'put', url: 'inventory/locations/{id}' },
        mapFaultyAsset: { method: 'post', url: 'assets/map-faulty-asset' },
        editWarehouse: { method: 'put', url: 'inventory/locations/{id}' },
        deleteAsset: { method: 'delete', url: 'assets/{id}' },
        locationsFilterList: { method: 'get', url: 'inventory/locations/filter-list' },
        assetsFilterList: { method: 'get', url: 'assets/filter-list' },
        generateTags: { method: 'post', url: 'assets/tag' },
        createBoq: { method: 'post', url: 'assets/add-boq' },
        locationsDetails: { method: 'get', url: 'inventory/locations/details' },
        assetHistory: { method: 'get', url: 'assets/{id}/history' },
        getLocationById: { method: 'put', url: 'inventory/locations/{id}' },
        changeWarehouse: { method: 'put', url: 'assets/warehouse' }
    },

    serviceRequest: {
        getServiceRequest: { method: 'get', url: 'tickets' },
        createServiceRequest: { method: 'post', url: 'tickets' },
        getServiceRequestCount: { method: 'get', url: 'tickets/count' },
        getServiceRequestFilterList: { method: 'get', url: 'tickets/filter-list' },
        getById: { method: 'get', url: 'tickets/{ticketId}' },
        updateServiceRequest: { method: 'put', url: 'tickets/{ticketId}' },
        deleteServiceRequest: { method: 'delete', url: 'tickets/{ticketId}' },
        getEligibleAgents: { method: 'post', url: 'tickets/{ticketId}/agents/eligible' },
        addAgentsToTicket: { method: 'post', url: 'tickets/{ticketId}/agents' },
        holdOrResumeServiceRequest: { method: 'put', url: 'tickets/{ticketId}/state/{state}' },
        bulkHoldOrResumeServiceRequest: { method: 'put', url: 'tickets/state/{state}/bulk' },
        hardCloseServiceRequest: { method: 'put', url: 'tickets/{ticketId}/hard-close' },
        bulkTicketCreate: { method: 'post', url: 'bulk/create' },
        bulkExampleFile: { method: 'get', url: 'bulk/example-file' },
        assignHelpdesk: { method: 'post', url: 'tickets/{ticketId}/assign-helpdesk' },
        updateRma: { method: 'post', url: 'assets/update-rma' },
        triggeredServiceRequest: { method: 'get', url: 'tickets/triggered' },
        updateRemark: { method: 'put', url: 'tickets/{ticketId}/remark/{ledgerId}' },
        addAttributes: { method: 'post', url: 'tickets/{ticketId}/attributes/{key}' },
        extraDetailsByIds: { method: 'get', url: 'tickets/details' },
        cloneTicket: { method: 'post', url: 'tickets/{ticketId}/clone' },
        history: { method: 'get', url: 'tickets/{ticketId}/history' },
        bulkCloneTicket: { method: 'post', url: 'tickets/bulk-clone' },
        bulkDeleteTicket: { method: 'post', url: 'tickets/bulk-delete' },
        bulkEditExecutionDate: { method: 'post', url: 'tickets/bulk-execution-date' },
        bulkAssign: { method: 'post', url: 'tickets/bulk-agents' },
        addRemark: { method: 'post', url: 'tickets/{ticketId}/remark' },
        bulkRemoveAgent: { method: 'post', url: 'tickets/agents' },
        signoffReport: { method: 'post', url: 'tickets/{ticketId}/signoff-template' },
        report: { method: 'post', url: 'tickets/{ticketId}/report' },
        updateNoResponse: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/update-no-reponse/event/{event}' },
        count: { method: 'get', url: 'tickets/count/v2' },
        bulkBroadcast: { method: 'post', url: 'bulk/broadcast' },
        downloadCustomerSignoffReport: { method: 'post', url: 'reports/zip/request' },
        customerApprovalRecieved: { method: 'post', url: 'tickets/customer-approval-received' },
        revokeCustomerApproval: { method: 'post', url: 'tickets/customer-approval-received/revoke' },
        getBillingRemarks: { method: 'get', url: 'tickets/billing/remarks' },
        editCustomer: { method: 'put', url: 'tickets/{id}/report' },
        bulkSignoffUnlock: { method: 'post', url: 'tickets/signoff-unlock/bulk' },
        removeAssetFromTicket: { method: 'post', url: 'assets/{asset_id}/ticket-remove' },
        fixRma: { method: 'post', url: 'tickets/{id}/milestones/{milestoneId}/fix-rma' },
        getServiceRequestCountByStatus: { method: 'get', url: 'tickets/count/status' },
        visitHistory: { method: 'get', url: 'tickets/{ticketId}/visit-history' },
        getAllTicketPaymentsCount: { method: 'get', url: 'tickets/payments/count' },
    },
    assetConfig: {
        getAssetConfigs: { method: 'get', url: 'asset-configs' },
        updateAssetConfig: { method: 'put', url: 'asset-configs/{id}' },
    },
    utils: {
        getPreferences: { method: 'get', url: 'preferences' },
    },
    milestones: {
        getMilestones: { method: 'get', url: 'admin/milestones' },
        accept: { method: 'put', url: 'tickets/{ticketId}/milestones/{milestoneId}/accept' },
        assign: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/agents' },
        reAssign: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/reassign-agents' },
        broadcast: { method: 'put', url: 'tickets/{ticketId}/milestones/{milestoneId}/broadcast' },
        siteComplete: { method: 'put', url: 'tickets/{ticketId}/milestones/{milestoneId}/site-completed' },
        executionDate: { method: 'put', url: 'tickets/{ticketId}/milestones/{milestoneId}/execution-date' },
        reachedSite: { method: 'put', url: 'tickets/{ticketId}/milestones/{milestoneId}/reached-site' },
        approve: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/signoff-accepted' },
        reject: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/signoff-rejected' },
        raiseSignoff: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/raise-signoff' },
        releaseVendor: { method: 'post', url: "tickets/{ticketId}/milestones/{milestoneId}/release-vendor" },
        goingToSite: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/tracking-enabled' },
        addMilestone: { method: 'post', url: 'tickets/{ticketId}/milestones' },
        unlockSignoff: { method: 'put', url: 'tickets/{ticketId}/milestones/{milestoneId}/signoff-unlock' },
        updateCustomerSignoffStatus: { method: 'post', url: 'tickets/{id}/milestones/{milestoneId}/update-signoff-status' },
        assetPhysicalVerification: { method: 'post', url: 'tickets/{ticketId}/milestones/{milestoneId}/assets/{assetId}/physical-verification' },
    },
    serviceRequestPayments: {
        getAllTicketaPayments: { method: 'get', url: 'tickets/payments' },
        findAllTicketaPayments: { method: 'post', url: 'tickets/payments' },
        createOrEdit: { method: 'post', url: 'tickets/{ticketId}/payments' },
        approve: { method: 'post', url: 'tickets/{ticketId}/payments/approve' },
        reject: { method: 'post', url: 'tickets/{ticketId}/payments/reject' },
        rollback: { method: 'post', url: 'tickets/{ticketId}/payments/rollback' },
        getPayments: { method: 'get', url: 'tickets/{ticketId}/payments/{role}' },
        getMilestones: { method: 'get', url: 'tickets/{ticketId}/milestones' },
        hold: { method: 'post', url: 'tickets/{ticketId}/payments/hold' },
    },
    po: {
        create: { method: 'post', url: 'po' },
        list: { method: 'get', url: 'po' },
        getById: { method: 'get', url: 'po/{id}' },
        update: { method: 'put', url: 'po/{id}' },
        delete: { method: 'delete', url: 'po/{id}' },
        deletePurge: { method: 'delete', url: 'po/{id}/purge' },
        addLineItems: { method: 'post', url: 'po/{id}/line-items' },
        updateLineItems: { method: 'put', url: 'po/{id}/line-items/{itemId}' },
        deleteLineItems: { method: 'delete', url: 'po/{id}/line-items/{itemId}' },
        cancel: { method: 'post', url: 'po/{id}/cancel' },
        payToVendorsWallet: { method: 'post', url: 'po/{id}/line-items/{itemId}/pay/w2w' },
        payToVendorsBank: { method: 'post', url: 'po/{id}/line-items/{itemId}/pay/w2b' },
        payManually: { method: 'post', url: 'po/{id}/line-items/{itemId}/pay/offline' },
        editLineItems: { method: 'put', url: 'po/{id}/line-items/{itemId}' },
        approveOrRejectPo: { method: 'post', url: 'po/{id}/close' },
        addApprovers: { method: 'post', url: 'po/{id}/approvers/level' },
        deleteApprovers: { method: 'delete', url: 'po/{id}/approvers/level/{levelId}' },
        payTaxWallet: { method: 'post', url: 'po/{id}/tax/pay/w2w' },
        payTaxBank: { method: 'post', url: 'po/{id}/tax/pay/w2b' },
        filterList: { method: 'get', url: 'po/filter-list' },
        generateQuotationPdf: { method: 'patch', url: 'po/{id}/quotation-pdf' },
        generateApprovedPdf: { method: 'patch', url: 'po/{id}/approved-pdf' },
    },

    invoice: {
        get: { method: 'get', url: 'invoices' },
        create: { method: 'post', url: 'invoices' },
        filterList: { method: 'get', url: '/invoices/filter-list' },
    },

    media: {
        updateStatus: { method: 'post', url: 'media/{id}/update-media-status' },
        transform: { method: 'post', url: 'media/{id}/transform' },
    },
    reports: {
        getColumns: { method: 'get', url: 'reports/{report}/coulmns' },
        request: { method: 'post', url: 'reports/request' },
    },
    webhooks: {
        ticketDetails: { method: 'get', url: 'webhooks/tickets/{ticketId}' },
    },
    chat: {
        closeChat: { method: 'post', url: 'chats/{id}/close' }
    },
    alert: {
        sendAlert: { method: 'post', url: 'alert/whatsapp' },
        getIntalkCredentials: { method: 'post', url: 'alert/intalk-credentials' },
    }
};

export default urls;
